// Who lands where. 3CX-style two-surface model: admins use the admin console
// (and can hop to the webclient); everyone else gets the user webclient only.
//
// The JWT carries { role: 'super_admin' | 'reseller' | 'user', app_role }.
// app_role is an optional per-extension console role (stratus_ext.user_settings);
// anything matching /admin/ is treated as console-capable.

export type Me = { role?: string; app_role?: string | null; username?: string; domain_uuid?: string } | null;

export function isAdminRole(me: Me): boolean {
  if (!me) return false;
  if (me.role === 'super_admin' || me.role === 'reseller') return true;
  if (me.app_role && /admin/i.test(me.app_role)) return true;
  return false;
}
